var map = {
	"./caishijie/helper3.png": "e50c",
	"./caishuju/helper3.png": "68aa",
	"./cqssc/helper3.png": "1303",
	"./gd10/helper3.png": "0da7",
	"./liuhe/helper3.png": "20f8",
	"./madou/helper3.png": "b29f",
	"./pcdd/helper3.png": "02e0",
	"./pk10/helper3.png": "9cfe",
	"./xyft/helper3.png": "8b5c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a749";